module.exports = __webpack_public_path__ + "img/pz.ed3bf17a.jpg";